<template>

  <!-- movie view -->
  <div v-bind:class="['movie-modal', { 'is-loaded' : isLoaded }, { 'is-not-moving' : !isMoving }]">
    
    <!-- video player -->
    <video-player :options="videoOptions" @player-state-changed="playerStateChanged" ref="myPlayer"></video-player>

    <!-- spinner -->
    <clip-loader :loading="loading" :color="color"></clip-loader>

    <!-- back to movie (arrow) -->
    <div v-bind:class="['controls-panel second', { 'is-movie' : !isMovie }]">
      <ul class="controls" v-if="this.movie && this.movie.slug">
        <li class="arrow" @click="disableTooltips()" v-tooltip.top-right="'back to ' + this.movie.title_tmdb_original">
          <router-link :to="{ name: 'movie', params: { slug: this.movie.slug }}">
            <img class="playing-movie-thumbnail" :src="'https://image.tmdb.org/t/p/w500' + (movie.backdrops ? movie.backdrops[0] : movie.poster)"/>
            <svg enable-background="new 0 0 256 256" height="256px" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path  d="M91.474,33.861l-89.6,89.6c-2.5,2.5-2.5,6.551,0,9.051l89.6,89.6c2.5,2.5,6.551,2.5,9.051,0s2.5-6.742,0-9.242L21.849,134  H249.6c3.535,0,6.4-2.466,6.4-6s-2.865-6-6.4-6H21.849l78.676-78.881c1.25-1.25,1.875-2.993,1.875-4.629s-0.625-3.326-1.875-4.576  C98.024,31.413,93.974,31.361,91.474,33.861z"/></svg>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- movie menu -->
    <div v-if="this.movie" v-bind:class="['controls-panel main', { 'is-playing' : !isPlaying }, { 'is-show' : isMoving }]" >
      <ul class="controls">
        <li @click="closeMovie()" class="arrow" v-if="this.filter===''">
          <div class="tooltip-container" v-tooltip.top-left="'back to list'">
            <router-link :to="{ name: 'home'}">
              <svg enable-background="new 0 0 256 256" height="256px" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
            </router-link>
          </div>
        </li>
        <li @click="closeMovie()" class="arrow" v-if="this.filter!==''" v-tooltip.top-left="'back to list'">
          <div class="tooltip-container" v-tooltip.top-left="'back to list'">
            <router-link :to="{ name: 'genre', params: { genre: this.filter }}">
              <svg enable-background="new 0 0 256 256" height="256px" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
            </router-link>
          </div>
        </li>
        <li v-if="this.movie.title_tmdb" @click="toggleInfos()" v-bind:class="['infos-cta', { 'menu-is-active' : infosActive }]">
          <div class="tooltip-container" v-tooltip.top-center="'infos'">
            <h3>i</h3>
          </div>          
        </li>
        <li v-if="this.movie.title_tmdb && videoOptions.source.src" @click="toggleDownload()" v-bind:class="['download', { 'menu-is-active' : downloadActive }]">
          <div class="tooltip-container" v-tooltip.top-center="'download'">
            <svg height="19px" version="1.1" viewBox="0 0 14 19" width="14px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title/><desc/><defs/><g stroke="none" stroke-width="1"><g  transform="translate(-383.000000, -213.000000)"><g id="file-download" transform="translate(383.000000, 213.500000)"><path d="M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 L0,15 Z" /></g></g></g></svg>
          </div>
        </li>
        <li v-if="this.movie && this.movie.backdrops" @click="toggleMosaic()" v-bind:class="['backdrops-cta', { 'menu-is-active' : mosaicActive }]">
          <div class="tooltip-container" v-tooltip.top-center="'gallery'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 965.199 965.199" style="enable-background:new 0 0 965.199 965.199;" xml:space="preserve"><g><path d="M263.85,30c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202.1c0,16.6,13.4,30,30,30h202.1c16.6,0,30-13.4,30-30V30   H263.85z" fill="#FFFFFF"/><path d="M613.55,30c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202.1c0,16.6,13.4,30,30,30h202c16.6,0,30-13.4,30-30V30z" fill="#FFFFFF"/><path d="M963.25,30c0-16.6-13.4-30-30-30h-202c-16.601,0-30,13.4-30,30v202.1c0,16.6,13.399,30,30,30h202.1c16.601,0,30-13.4,30-30   V30H963.25z" fill="#FFFFFF"/><path d="M263.85,381.6c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202c0,16.6,13.4,30,30,30h202.1c16.6,0,30-13.4,30-30v-202   H263.85z" fill="#FFFFFF"/><path d="M613.55,381.6c0-16.6-13.4-30-30-30h-202c-16.6,0-30,13.4-30,30v202c0,16.6,13.4,30,30,30h202c16.6,0,30-13.4,30-30V381.6z" fill="#FFFFFF"/><path d="M963.25,381.6c0-16.6-13.4-30-30-30h-202c-16.601,0-30,13.4-30,30v202c0,16.6,13.399,30,30,30h202.1   c16.601,0,30-13.4,30-30v-202H963.25z" fill="#FFFFFF"/><path d="M233.85,703.1h-202c-16.6,0-30,13.4-30,30v202.1c0,16.602,13.4,30,30,30h202.1c16.6,0,30-13.398,30-30V733.1   C263.85,716.6,250.45,703.1,233.85,703.1z" fill="#FFFFFF"/><path d="M583.55,703.1h-202c-16.6,0-30,13.4-30,30v202.1c0,16.602,13.4,30,30,30h202c16.6,0,30-13.398,30-30V733.1   C613.55,716.6,600.149,703.1,583.55,703.1z" fill="#FFFFFF"/><path d="M933.25,703.1h-202c-16.601,0-30,13.4-30,30v202.1c0,16.602,13.399,30,30,30h202.1c16.601,0,30-13.398,30-30V733.1   C963.25,716.6,949.85,703.1,933.25,703.1z" fill="#FFFFFF"/></g>
            </svg>
          </div>
        </li>       
        <li v-if='this.movie.title_tmdb' v-bind:class="['title', { 'hide-title' : (infosActive || !titleActive) }]">
          <h1>{{ this.movie.title_tmdb }}</h1>
        </li>
      </ul>

      <!-- info window -->
      <span v-bind:class="['submenu-arrow infos-arrow', { 'submenu-active' : infosActive }]"></span>
      <div v-bind:class="['submenu infos', { 'submenu-active' : infosActive }]">
        <h1>{{ this.movie.title_tmdb }}</h1>       
        <h3 v-if='this.movie.director'>{{ this.movie.director.join(" & ") }}, {{ this.movie.date }}</h3>

        <div v-if='this.movie.title_tmdb_original !== this.movie.title_tmdb'>
        <br>
        <b>{{ this.movie.title_tmdb_original }}</b>
        <br>
        (original title)
        </div>
        
        <p>{{ this.movie.overview }}</p>

        <p>{{ this.movie.duration }} minutes</p>

        <p v-if='this.movie.cast'>With {{ this.movie.cast.join(", ") }}.</p>
        
        <div>
          <!-- <p>{{ this.movie.synopsis }}</p> -->
          <h4 v-if='this.movie.genres'>
            <div v-for="genre in this.movie.genres" class="movie-genre">
              <router-link :to="{ name: 'genre', params: { genre: genre }}">
                <span @click="updateFilterTag(genre)">{{ genre }}</span>
              </router-link>
              <span class="movie-genre-spacer">| </span>
            </div>
          </h4>
          
          <h4>
            <a :href="'https://archive.org/details/' + this.movie.id_archive " target="_blank" title="see the movie on archive.org - new tab">Internet Archive</a>
            -
            <a :href="'https://www.themoviedb.org/movie/' + this.movie.id_tmdb " target="_blank" title="see the movie on themoviedb.org - new tab">TMDb</a>
            -
            <a v-if='this.movie.id_imdb' :href="'https://www.imdb.com/title/' + this.movie.id_imdb " target="_blank" title="see the movie on imdb.com - new tab">IMDb</a>
          </h4>
        </div>

      </div>

      <!-- download window -->
      <span v-bind:class="['submenu-arrow download-arrow', { 'submenu-active' : downloadActive }]"></span>
      <div v-bind:class="['submenu download', { 'submenu-active' : downloadActive }]">
        <a :href="videoOptions.source.src" download>
          click to direct download .mp4 file
        </a>
      </div>

      <!-- mosaic window -->
      <span v-bind:class="['submenu-arrow mosaic-arrow', { 'submenu-active' : mosaicActive }]"></span>
      <div v-bind:class="['submenu mosaic', { 'submenu-active' : mosaicActive }]">      
        <img v-for="(backdrop, iBackdrop) in movie.backdrops" @click="openGallery(iBackdrop)" :src="'https://image.tmdb.org/t/p/w342' + backdrop" alt="" class="mosaic-thumbnail">        
      </div>

    </div>

    <!-- gallery -->
    <div v-bind:class="['gallery', { 'gallery-active' : galleryActive }]">
      <div @click="closeGallery()" class="cross">
        <svg enable-background="new 0 0 256 256" height="256px" id="Layer_1" version="1.1" viewBox="0 0 256 256" width="256px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
          </router-link>
      </div>
      <div  @click="goRight()" class="arrow left">
        <svg enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path clip-rule="evenodd" d="M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z" fill-rule="evenodd" /></svg>
        <div class="arrow-clickzone"></div>
      </div>
      <div @click="goLeft()" class="arrow right">
        <svg enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path clip-rule="evenodd" d="M11.262,16.714l9.002,8.999  c0.395,0.394,1.035,0.394,1.431,0c0.395-0.394,0.395-1.034,0-1.428L13.407,16l8.287-8.285c0.395-0.394,0.395-1.034,0-1.429  c-0.395-0.394-1.036-0.394-1.431,0l-9.002,8.999C10.872,15.675,10.872,16.325,11.262,16.714z" fill-rule="evenodd" /></svg>
        <div class="arrow-clickzone"></div>
      </div>
      <div id="gallery-content" class="gallery-content" v-on-clickaway="away">
        <div v-for="(backdrop, iBackdrop) in movie.backdrops" class="gallery-images" v-bind:style="{ backgroundImage: 'url(https://image.tmdb.org/t/p/w1280' + (backdrop ? backdrop : this.movie.poster) + '), url(https://image.tmdb.org/t/p/w342' + (backdrop ? backdrop : this.movie.poster) + ')' }">
          <a :href="'https://image.tmdb.org/t/p/original' + backdrop"  download>
            <svg height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M31,22c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.448,31.552,22,31,22z" /><path d="M15.27,23.707c0.389,0.385,1.04,0.389,1.429,0l6.999-6.9c0.395-0.391,0.394-1.024,0-1.414   c-0.394-0.391-1.034-0.391-1.428,0l-5.275,5.2V1c0-0.552-0.452-1-1.01-1c-0.558,0-1.01,0.448-1.01,1v19.593l-5.275-5.2   c-0.395-0.391-1.034-0.391-1.428,0c-0.395,0.391-0.395,1.024,0,1.414L15.27,23.707z" /></svg>
          </a>
        </div>
      </div>
    </div>
    
    <!--  <div @click="testclick()" class="testdebug">CLICK MEEEE</div> -->

  </div>  

</template>

<script>

import Vue from 'vue'
import firebase from 'firebase'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { videoPlayer } from 'vue-video-player' //https://github.com/surmon-china/vue-video-player

// for gallery
import { mixin as clickaway } from 'vue-clickaway'; // https://github.com/simplesmiler/vue-clickaway

//util
import { removeClasses } from '../utils/utils'

//https://github.com/Akryum/vue-tooltip
import VTooltip from 'v-tooltip' 
Vue.use(VTooltip)





// for subtitle
// testing
// import srt2vtt from 'srt2vtt2'
//import iconv from 'iconv-lite'
// var http = require('http'),
//     iconv = require('iconv-lite'),
//     JSONP = require('node-jsonp');


//import request from 'request'

//iconv = require('iconv-lite');
// var url = 'https://dl.opensubtitles.org/en/download/subencoding-utf8/filead/src-api/vrf-e9810b84/sid-Dq6mXFYJ9K6b0BJDYXkbmYjlp5c/file/163809';
// var options = { method: 'GET', url:'http://dl.opensubtitles.org/en/download/src-api/vrf-19950c4c/sid-riu8Tg8a,1NEg8djD96BVrnLWj2/file/1954134224'};

// request(options, function (error, response, body) {
//     if (error) throw new Error(error);

//     var formattedData = iconv.decode(body, 'iso-8859-1');
//     console.log(formattedData);

// });

// http.get(url, function(res) {
//   var body = '';
//   res.on('data', function(chunk) {
//     body += chunk;
//   });
//   res.on('end', function() {
//     var decodedBody = iconv.decode(body, 'win1252');
//     console.log(decodedBody);
//   });
// });

// http.get(url, function(res) {
//   var chunks = [];
//   res.on('data', function(chunk) {
//     chunks.push(chunk);
//   });
//   res.on('end', function() {
//     var decodedBody = iconv.decode(Buffer.concat(chunks), 'win1252');
//     console.log(decodedBody);
//   });
// });

//     JSONP('url',function(json){
//      console.log(json)
//     })

export default {
  
  name: 'Movie',

  components: {
    ClipLoader,
    videoPlayer,
  },

  props: {    
    filter: String,
    handleUpdateFilterTag: Function,
    preLoadingImage: String,
  },

  mixins: [ clickaway ],

  mounted: function () {
    var slug = this.$route.params.slug;    
    if(slug){
      document.body.className = 'no-scroll';  
    }else{
      document.body.className = 'movieIsClosed';  
    }

    //console.log('this is current player object', this.player)
    
    //attach event to play/pause with space
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('mousemove', this.showInfo);
  },
  beforeDestroy: function () {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('mousemove', this.showInfo);
  },

  destroyed: function () {    
    document.body.className = '';
  },

  data: function () {

    this.firebaseUpdate();
        //to do var slug = this.$route.params.slug; sur le loading
    return {      
      pageTitle: this.pageTitle ? this.pageTitle : 'Loading..',
      metaImg: '/static/img/tarot_sun.28c2a2b.svg',
      loading: this.loading === undefined ? true : this.loading,
      color: '#2c3e50',
      movie: {},
      timeOutVariable: '',
      isPlaying: false,
      isLoaded: false,
      isMoving: false,
      titleActive: true,
      infosActive: false,
      mosaicActive: false,
      downloadActive: false,
      galleryActive: false,
      galleryWidth: '',
      galleryLength: '',
      gallery : '',
      imageSize : 800,
      posXGallery: '',
      posGallery: 0,
      videoOptions: {
        source: {
          type: "video/mp4",
          src: 'https://archive.org/download/YongaryMonsterFromTheDeep/YongaryMonsterFromTheDeepHostedByTheCinematedMan.mp4',
          customEventName : 'player-state-changed'
          // if you need custom player state changed event name, you can config it like this
          //customEventName: 'my-player-state-changed-event-custom-name'
        },
        poster: '',
        height: window.innerHeight,
        preload: 'none',

        autoplay: false,
      },    
      isMobile : '',


    }
  },
  computed: {
    player() {
      return this.$refs.myPlayer.player
    }
  },

  methods: {

    //for gallery
    away: function(e) {
      //console.log('clicked away');
      
      if( !this.galleryActive || 
          e.target.className==='mosaic-thumbnail' ||
          e.target.className==='arrow-clickzone' 
        ){
        return false;
      }
        
      this.closeGallery();
    },


    handleKeyDown: function(e) {

      // Ignore regular keys when focused on a field
      // and no modifiers are active.
      if ((
        !e.ctrlKey && !e.metaKey && !e.altKey
      ) && (
        e.target.tagName === 'INPUT' ||
        e.target.tagName === 'SELECT' ||
        e.target.tagName === 'TEXTAREA' ||
        e.target.isContentEditable
      )) {
        return;
      }

      const keyCode = e.keyCode || e.which;

      // console.log("keyCode: ", keyCode);

      if (keyCode === 32) { //SPACE
        //e.preventDefault(); //commented to allow normal space scroll behaviour 
        if(document.body.className === 'movieIsClosed'){ //to do properly with a class ?
          return false;
        }
        this.playPause();
      }else if (keyCode === 27) { //ESCAPE
        e.preventDefault();

        if(document.body.className === 'movieIsClosed'){
          if(!this.movie.slug){
            return false;
          }
          this.$router.push('/movie/'+this.movie.slug);
        }else{
          this.closeMovie();
          if(this.filter===''){
            this.$router.push('/');
          }else{
            this.$router.push('/genre/'+this.filter);
          }
        }


      }
    },

    showInfo: function() {
      if(this.timeOutVariable){
        clearTimeout(this.timeOutVariable);
      }
      this.isMoving = true;
      this.timeOutVariable = setTimeout(function(){ this.isMoving = false; }.bind(this), 2500);
    },
    testclick: function() {
    },
    initGallery: function() {
      this.galleryLength = this.movie.backdrops.length;
      this.galleryWidth = this.galleryLength * this.imageSize;
      this.gallery = document.getElementById("gallery-content");
      this.gallery.style.width = this.galleryWidth + 'px';
      this.posXGallery = -this.imageSize/2;
    },
    goLeft: function() {
      var that = this;
      if (that.posGallery < that.galleryLength-1) {
        var newPosXGallery = that.posXGallery - that.imageSize;
        that.gallery.style.transform = "translate("+ newPosXGallery+"px"+",-50%)"
        that.posXGallery = newPosXGallery;
        that.posGallery++;
      }else {
        that.posGallery = 0;
        that.posXGallery = -that.imageSize/2;
        that.gallery.style.transform = "translate("+that.posXGallery+"px"+",-50%)";
      }
    },
    goRight: function() {
      var that = this;
      if(that.posGallery > 0) {
        var newPosXGallery = that.posXGallery + that.imageSize;
        that.gallery.style.transform = "translate("+ newPosXGallery+"px"+",-50%)"
        that.posXGallery = newPosXGallery;
        that.posGallery--;
      } else {
        that.posGallery = that.galleryLength - 1;
        that.openGallery(that.posGallery);
      }
    },
    closeGallery: function() {
      this.galleryActive = !this.galleryActive;
      this.posGallery = 0;
      this.posXGallery = -this.imageSize/2;
    },
    openGallery: function(i) {
      this.galleryActive = true;
      var newPosXGallery = this.posXGallery - this.imageSize * i;
      this.gallery.style.transform = "translate("+ newPosXGallery +"px"+",-50%)"
      this.posXGallery = newPosXGallery;
      this.posGallery = i;
    },
    disableTooltips: function () {
      //to fix tooltip that stays open without the mouse moving
      var toolipOpen = document.querySelector('.tooltip-after-open')
      if(toolipOpen){
        //console.log("toolipOpen: ", toolipOpen);
        removeClasses(toolipOpen, 'tooltip-enabled tooltip-open tooltip-after-open');
      }
    },
    closeMovie: function () {      
      document.body.className = 'movieIsClosed';
      this.player.pause();
      this.mosaicActive = false;
      this.infosActive = false;
      this.downloadActive = false;

      this.disableTooltips();
    },

    updateFilterTag: function (key) {
      this.handleUpdateFilterTag(key);
      this.closeMovie();
    },
    playPause: function() {
      // console.log('playPause kikoo');
      if(!this.isPlaying) {
        this.player.pause();

        this.pageTitle = this.movie.title_tmdb_original;
        this.$emit('updateHead');
      }
      else {
        this.player.play();
        
        this.pageTitle = '► '+this.pageTitle;        
        this.$emit('updateHead');
      }
    },

    playerStateChanged: function(playerCurrentState) {
      // console.log("playerCurrentState: ", playerCurrentState);

      this.isPlaying = this.player.paused();
    },
    toggleInfos: function()  {
      this.infosActive = !this.infosActive;
      this.mosaicActive = false;
      this.downloadActive = false;
    },
    toggleDownload: function()  {
      this.downloadActive = !this.downloadActive;
      this.infosActive = false;
      this.mosaicActive = false;
    },
    toggleMosaic: function()  {
      this.mosaicActive = !this.mosaicActive;
      this.infosActive = false;
      this.downloadActive = false;
    },
    firebaseUpdate: function () {
      //console.log("in UPDATE firebase");

      var routeName = this.$route.name;
      if(routeName === "home"){
        this.pageTitle = "HOME";
      }else if(routeName === "genre"){    
        this.pageTitle = this.$route.params.genre;
      }
      //we update pageTitle for 'home' and 'genre'
      if(routeName !== "movie"){        
        this.$emit('updateHead');
        //exit now to avoid firebase call
        return false;        
      }



      //to get ride of the scroll on movie page
      document.body.className = 'no-scroll';

      
      //to get the movie based on slug
      var slug = this.$route.params.slug;
      
      //if movie is already loaded
      if(this.movie && this.movie.slug && this.movie.slug === slug){
        this.pageTitle = this.movie.title_tmdb_original;
        this.metaImg = this.movie.poster;
        this.$emit('updateHead');
        return false;
      }else if(this.preLoadingImage !== ''){        
        //otherwise we hide title
        this.titleActive = false;
        
        //otherwise we force background to update immediately (so the user won't see the image transition)
        var vjsposter = document.getElementsByClassName("vjs-poster");
        if (vjsposter !== null){            
          vjsposter[0].classList.remove("vjs-hidden");
          vjsposter[0].style.backgroundImage = 'url(https://image.tmdb.org/t/p/w500' + this.preLoadingImage + ')';
        }
      }


      var dataSingleMovie = firebase
        .database()
        .ref()
        .orderByChild('slug')
        .equalTo(slug)
        .limitToFirst(1);

      //to handle the spinner and some other things
      var that = this;
      dataSingleMovie.on("child_added", function(snapshot) {
        // console.log("child_added");
        that.isLoaded = true;

        var snap = snapshot.val();
        that.movie = snap;
        that.titleActive = true;
        that.loading = false;
        that.pageTitle = snap.title_tmdb_original;
        that.metaImg = snap.poster; //to do, poster for now but supposed to be backdrop
        that.$emit('updateHead');
        if(that.movie.backdrops)
          that.initGallery();

        that.videoOptions.source.src = 'https://archive.org/download/' + snap.id_archive + '/' + snap.video;
        //that.videoOptions.source.type = 'video/mp4'; // if we need dynamic source type
        
        // to preload only when a video has been requested 
        // (set to false for the default video during init)
        that.player.preload('auto');


        //dev test subtitles
        //NO SUPPORT FOR SRT FILES WITH VIDEOJS
        //Can try: down version of videojs, converting srt ourselves, changing videojs for something else..
        // that.player.addRemoteTextTrack({
        //   kind: 'captions',
        //   //src: 'http://dl.opensubtitles.org/en/download/src-api/vrf-19950c4c/sid-riu8Tg8a,1NEg8djD96BVrnLWj2/file/1954134224',
        //   //src: 'https://dl.opensubtitles.org/en/download/subformat-vtt/filead/src-api/vrf-19950c4c/sid-iMRFQUhDLo840fw2akpkWU7Taq6/file/1954134224',
        //   //src: 'https://dl.opensubtitles.org/en/download/subencoding-utf8/filead/src-api/vrf-e9810b84/sid-Dq6mXFYJ9K6b0BJDYXkbmYjlp5c/file/163809',

        //   //SUBFORMAT VTT NOT FUCKING WORKING
        //   src: 'https://dl.opensubtitles.org/en/download/subformat-vtt/filead/src-api/vrf-19950c4c/sid-iMRFQUhDLo840fw2akpkWU7Taq6/file/1954134224',
        //   srclang: 'fr',
        //   label: 'french'
        // });


        
 
        // var subtitles = "./test/subtitles.srt"

        // var subtitles = "http://dl.opensubtitles.org/en/download/src-api/vrf-19950c4c/sid-riu8Tg8a,1NEg8djD96BVrnLWj2/file/1954134224";
         
        // srt2vtt(subtitles, function(err, result){
        //     if(err) console.log("Error happened :(")
        //     console.log(JSON.stringify(result))
        // })







        if(snap.poster || snap.backdrops) {
          var new_poster_large = 'https://image.tmdb.org/t/p/w1280' + (snap.backdrops ? snap.backdrops[0] : snap.poster)
          var new_poster_small = 'https://image.tmdb.org/t/p/w500' + (snap.backdrops ? snap.backdrops[0] : snap.poster)

          //smooth background loading
          var vjsposter = document.getElementsByClassName("vjs-poster");
          if (vjsposter !== null){            
            vjsposter[0].classList.remove("vjs-hidden")
            vjsposter[0].style.backgroundImage = 'url(' + new_poster_large + '), url( ' + new_poster_small + ')';
          }
        }



        //console.log('this is current player object', that.player)

      }, function (error) {
        console.log("Error: " + error.code);
      });

    },
  },

  watch: {

    '$route' (to, from) {


      // console.log("WATCH route changed");
      // console.log("to: ", to);
      //this.toggleInfos();
      this.firebaseUpdate();
    }
  },

  // VueHead
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.pageTitle
      }
    },
    meta: function () {    
      return [

        { name: 'description', content: (this.$route.params.slug ? "« "+ this.$route.params.slug + " » Movie" : 'Online cinema with public domain movies.'), id: 'desc' },


        {property: "og:type", content: "website"},
        {property: "og:site_name", content: "Parvulesco"},
        {property: "og:title", content: "Parvulesco | Cinema App."},
        {property: "og:description", content: (this.$route.params.slug ? "« "+ this.$route.params.slug + " » Movie" : 'Online cinema with public domain movies.')},
        {property: "og:url", content: "https://parvulesco.herokuapp.com/"+(this.$route.params.slug ? 'movie/'+this.$route.params.slug : '')},
        {property: "og:image", content: this.$route.params.slug ? this.metaImg : '/static/img/tarot_sun.28c2a2b.svg'},

        {name: "twitter:card", content: "summary_large_image"},
        {name: "twitter:title", content: "Parvulesco | Cinema App."},
        {name: "twitter:description", content: (this.$route.params.slug ? "« "+ this.$route.params.slug + " » Movie" : 'Online cinema with public domain movies.')},        
        {name: "twitter:image", content: this.$route.params.slug ? this.metaImg : '/static/img/tarot_sun.28c2a2b.svg'},            
      ]

    }
  }

}


</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  
  .movieIsClosed .movie-modal{  
    transform: translateX(100%);
  }

  .hide{
    display: none;
  }
  .video-player {
    display: none;
    z-index: 1001;
    position:absolute;
    top: 0;
    left: 0;
    transform: translate(-0, -0);
    width: 100%;
    height: 100%;
    
    .video-js.vjs-custom-skin {
      height: 100% !important;
    }
    .video-js.vjs-custom-skin.vjs_video_3-dimensions {
      height: 100% !important;
    }

    //error modal
    .vjs-error .vjs-error-display .vjs-modal-dialog-content{
      bottom: 0;
      height: 80px;
      top: initial;
    }
  }
  .movie-modal{
    z-index: 100;
    background: black;
    transition: all .35s ease;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    color: #fff;
    overflow: visible;
    box-shadow: 2px 0 10px black;
    transition: all 0.15s ease;

    //not display play button on load
    .video-js.vjs-custom-skin .vjs-big-play-button{
      opacity: 0;
      transition: opacity 0.15s ease;
    }

    .video-js.vjs-custom-skin .vjs-control-bar .vjs-time-control.vjs-duration{
      margin-right: 22px;
    }
    .video-js.vjs-custom-skin .vjs-control-bar .vjs-play-control{
      margin-right: 20px;
    }

    &.is-loaded {
      z-index: 1001;

      .video-js.vjs-custom-skin .vjs-big-play-button{
        opacity: 1;
      }
      .video-player{
        display: block;
      }
    }
    &.is-not-moving{
      cursor: none;

      .controls-panel .controls li{
        cursor: none;
      }
    }

    .movie-background {
      position:absolute;
      top: 0;
      left:0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
    
    .main-play {
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 128px;
      height: 128px;
      background: url("../../static/img/play.svg");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  
  .controls-panel {
    z-index: 1002;
    transition: all 0.5s ease;
    &.is-playing {
      opacity: 0;
    }
    &.is-show {
      opacity: 1;
    }
    .controls {
      display: block;
      margin: auto;
      font-size: 0;
      li {
        cursor: pointer;
        vertical-align: middle;
        transition: all 0.15s ease;
        svg {
          width: 30px;
          height: 100%;
          transition: all 0.15s ease;
        }
        &.play {
          svg {
            display: block;
            width: 23px;
            height: 23px;
          }
          .is-playing-panel {
            opacity: 0;
            display: none;
          }
          .play-cta {
            
          }
          .pause-cta {
            display: block;
            margin-right: 2px;
          }
        }
      }
    }
    &.main {
      position:absolute;
      top: 44px;
      left: 30px;
      // max-height: calc(100% - 30px - 42px); // 30px: top, 42px: bottom (player)
      // height: auto;
      //height: 100%;

      .controls {
        width: auto;
        font-size: 0;
        li {
          position: relative;
          display: inline-block;
          height: 50px;
          width: 50px;
          background-color: rgba(0, 0, 0, 0.6);
          transition: all 0.3s ease;
          &:before {
              content: '';
              width: 1px;
              height: 25px;
              position:absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              background: #fff;    
            }
          &:first-child {
            &:before {
              display: none;
            }            
          }
         
          svg {
            display: block;
            margin: auto;
            fill: #d2d2d2;
            
          }
          &.title {
            width: auto;
            padding: 0 12px;
            transition: all 0.5s ease;
            cursor: initial;
            position: absolute;
           
            h1 {
              font-size: 21px;
              font-weight: 300;
              margin-top: 13px;
              transition: opacity 0.15s ease;
              white-space: nowrap;
            }
            &.hide-title {
              padding: 0;
              opacity: 0;
            }
          }
          &.backdrops-cta {
            svg {
              position:absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 31px;
              height: 31px;
            }
          }
          &.download {
            display: none;
          }
          &.backdrops-cta {
            svg {
              width: 23px;
            }
          }
          &.menu-is-active{
            background-color: rgba(58, 58, 58, 0.6);
          }
        }
        .infos-cta {
          position: relative;
          h3 {
            position:absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0;
            text-align: center;
            font-size: 30px;
            font-family: Arial, Helvetica, sans-serif;
            font-weight: 200px;
          }
          
        }
        .arrow {
          svg {
            //transform: rotate(180deg);
          }
        }
      }
    }
    &.second {
      position:absolute;
      top: 50%;
      left: -60px;
      width: 30px;
      transform: translateY(-50%); 
      height: auto;
      z-index: -1;
      .controls {
        li {
          display: block;
          .playing-movie-thumbnail{
            width: 80px;
          }
          svg {
            width: 25px;
            fill: #000;
            
          }
          &:last-child {
            margin-top: 10px;
          }
        } 
      }
      .arrow, .close, {
      }
    }
    .submenu-arrow {
      display: none;
      opacity: 0;
      width: 0px;
      height: 0px;
      margin-top: 7px;  
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(0, 0, 0, 0.6);
      &.infos-arrow {
        transform: translateX(65px);
      }
      &.download-arrow {
        transform: translateX(115px);
      }
      &.mosaic-arrow {
        transform: translateX(166px);
      }
    }
    .submenu {
      position: relative;
      display: none;
      opacity: 0;
      //max-height: calc(100% - 70px - 42px - 22px); // 70px: top, 42px: bottom (player), 22px: ?? + marge
      max-height: calc(100vh - 220px);
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 2px;
      overflow-y: auto;
      padding: 30px;
      &.infos {
        width: 320px;
      }
      &.download {
        a {
          padding: 6px 8px;
          background-color: rgba(0, 0, 0, 0.4);
        }        
      }
      &.mosaic {
        width: auto;
        max-width: 300px;
        font-size: 0;
        div {
          display: inline-block;
        }         
        img {
           display: inline-block;
          height: 84px;
          margin: 0;
          cursor: pointer;
        }        
      }
      h1 {
        font-size: 19px;
        color: white;
        text-transform: uppercase;
        font-weight: 600;
        margin: 0px;
        margin-top: 10px;
      }
      h3 {
        font-size: 13px;
        color: white;
        text-transform: uppercase;
        font-weight: 200;
        margin: 0px;
      }
      h4 {
        margin: 14px 0; 
      }
      p {
        font-weight: 200;
      }
      a {
        text-decoration: none;
        color: #fff;
      }
    }  
    .submenu-active {
      display: block;
      opacity: 1;
    } 
  }




  .gallery {
    display: none;
    &.gallery-active {
      display: block;
    }
    z-index: 1003;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    transition: all 0.15s ease;
    .cross {
      z-index: 10010;
      position: absolute;
      top: 30px;
      right: 30px;
      height: 35px;
      width: 35px;
      cursor: pointer;
      svg {
        height: 35px;
        width: 35px;
        fill: #d2d2d2;

      }

    }
    .arrow {
      z-index: 10010;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      display: block;
      background: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      &:hover {
        background: rgba(58, 58, 58, 0.6);
      }
      svg {
        position:absolute;
        top: 51%;
        left: 47%;
        transform: translate(-50%, -50%);   
        fill: #d2d2d2;
        width: 43px;
        height: 43px;
      }
      &.left {
        left: 30px;
      }
      &.right {
        right: 30px;
        transform: translateY(-50%) rotate(180deg);
      }
      .arrow-clickzone{
        height: 100%;
        position: relative;
      }
    }
    .gallery-content {
      transition: all 0.5s ease;
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-400px, -50%);
      height: 70%;
      width: auto;

      .gallery-images {
        position: relative;
        display: inline-block;
        width: 800px;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;

        a {
          opacity: 0;
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 35px;
          height: 35px;
          transition: all 0.5s ease;
          svg {
            height: 35px;
            width: 35px;
            fill: #d2d2d2;

          }
        }
        &:hover {
          a {
            opacity: 1;
          }
        }
      }
    }
  }



  .v-spinner{
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .controls-panel .submenu a{
    text-decoration: none;
    color: #2c3e50;
  }
  .movie-genre{
    display: inline;

    &:nth-last-child(1) .movie-genre-spacer{
      display: none;
    }
  }
  
  .testdebug{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background: red;
  }
  .movie-modal .vjs-poster {
    background-size: cover !important;
  }

  @keyframes bounce { 50% { transform: translateX(-3px); } 100% { transform: translateX(0px); } }

  .no-touchevents {
    .movie-modal {
      .controls-panel {
        &.second {
          .controls {
            li.arrow {
              &:hover svg{
                // fill: #601200;
                // transform: translateX(-6px);
                animation: bounce 0.8s linear infinite;
              }
            }
          }
        }
        &.main {
          .controls {
            li {
              &.download {
                display: inline-block;
                svg {
                  position:absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 26px;
                  height: 26px;
                  fill: #fff;
                }
              }
              &:hover {
                background-color: rgba(58, 58, 58, 0.6);
                fill: #fff;
              }
            }
          }
        }
      }
    }
    .gallery { 
      .arrow {
        &:hover {
          background: rgba(58, 58, 58, 0.6);
        }
      }
      .gallery-content {
        .gallery-images {
          &:hover {
            a {
              opacity: 1;
            }
          }
        }
      }
    }
    .controls-panel .submenu a{
      color: white;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .controls-panel {
      &.second {
          display: none;
      }
    }
  }
  @media screen and (max-width: 640px) {
    .controls-panel {
      &.main {
        left: 10px;
        top: 10px;
        .controls {
          li {
            &.title {
              display: none;
            }
          }
        }
      }
      .submenu {
        &.infos, &.mosaic {
          width: calc(100% - 70px);
          max-height: 230px;
        }
        &.mosaic {
          img {
            height: 70px;
          }
        }
      }
    }
  }



//dev
.tooltip-container{
  height: 100%;
}
.tooltip-element, .tooltip-element:after, .tooltip-element:before, .tooltip-element *, .tooltip-element *:after, .tooltip-element *:before {
  box-sizing: border-box; 
}
.tooltip-element {
  // display: none!important; //override tooltips behaviour to hide while dev
  display: none; //normal tooltips behaviour


  //transition: opacity 0.15s;
  transition: opacity 0s;
  z-index: 10000;
  position: absolute;  
}
.tooltip-element.tooltip-open {
  display: block;
  // transition: opacity 0s !important;
}
.tooltip-element {
  max-width: 100%;
  max-height: 100%; 
}
.tooltip-element .tooltip-content {
  border-radius: 0px;
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: rgba(0, 0, 0, 0.6);
  color: #eee;
  padding: 5px 10px 4px;
  font-size: 1.0em;
  line-height: 1.2em; 
}
.tooltip-element .tooltip-content:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-width: 8px;
  border-style: solid; 
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-center .tooltip-content {
  margin-bottom: 8px;
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-center .tooltip-content:before {
  top: 100%;
  left: 50%;
  margin-left: -8px;
  border-top-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-center .tooltip-content {
  margin-top: 8px;
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-center .tooltip-content:before {
  bottom: 100%;
  left: 50%;
  margin-left: -8px;
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-right.tooltip-element-attached-middle .tooltip-content {
  margin-right: 8px;
}
.tooltip-element.tooltip-element-attached-right.tooltip-element-attached-middle .tooltip-content:before {
  left: 100%;
  top: 50%;
  margin-top: -8px;
  border-left-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-left.tooltip-element-attached-middle .tooltip-content {
  margin-left: 8px;
}
.tooltip-element.tooltip-element-attached-left.tooltip-element-attached-middle .tooltip-content:before {
  right: 100%;
  top: 50%;
  margin-top: -8px;
  border-right-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-left.tooltip-target-attached-bottom .tooltip-content {
  margin-top: 8px;
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-left.tooltip-target-attached-bottom .tooltip-content:before {
  bottom: 100%;
  left: 8px;
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-right.tooltip-target-attached-bottom .tooltip-content {
  margin-top: 8px;
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-right.tooltip-target-attached-bottom .tooltip-content:before {
  bottom: 100%;
  right: 8px;
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-left.tooltip-target-attached-top .tooltip-content {
  margin-bottom: 8px;
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-left.tooltip-target-attached-top .tooltip-content:before {
  top: 100%;
  left: 17px;
  border-top-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-right.tooltip-target-attached-top .tooltip-content {
  margin-bottom: 8px;
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-right.tooltip-target-attached-top .tooltip-content:before {
  top: 100%;
  right: 8px;
  border-top-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-right.tooltip-target-attached-left .tooltip-content {
  margin-right: 8px;
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-right.tooltip-target-attached-left .tooltip-content:before {
  top: 8px;
  left: 100%;
  border-left-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-left.tooltip-target-attached-right .tooltip-content {
  margin-left: 8px;
}
.tooltip-element.tooltip-element-attached-top.tooltip-element-attached-left.tooltip-target-attached-right .tooltip-content:before {
  top: 8px;
  right: 100%;
  border-right-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-right.tooltip-target-attached-left .tooltip-content {
  margin-right: 8px;
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-right.tooltip-target-attached-left .tooltip-content:before {
  bottom: 8px;
  left: 100%;
  border-left-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-left.tooltip-target-attached-right .tooltip-content {
  margin-left: 8px;
}
.tooltip-element.tooltip-element-attached-bottom.tooltip-element-attached-left.tooltip-target-attached-right .tooltip-content:before {
  bottom: 8px;
  right: 100%;
  border-right-color: rgba(0, 0, 0, 0.6);
}
.tooltip-element {
  pointer-events: none;
}
.tooltip-element .tooltip-content {
  padding: 0.2em 0.4em;
}




</style>



// WEBPACK FOOTER //
// Movie.vue?fefa9edc